import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSeo } from './-components/page-seo';
import { slugs } from './contact.meta';

/**
 * A chooser, not a redirect to a default questionnaire: every generic "Contact us" links here, and a
 * default would file them all under one category (TEC-3821 B13).
 */
export const Route = createFileRoute('/www/contact/')({
	component: Component,
});

function Component() {
	const { t } = useLingui();

	return (
		<PageSeo
			slugs={slugs}
			title={t`Contact - Worldcoo`}
			description={t`If you'd like to incorporate Charity Rounding Up, if you're a social entity, or if you'd like some more information, please contact us.`}
		/>
	);
}
